<template>
  <HomeSlider />
  <Services id="services" />
  <News />
  <About/>
  <App/>
  <Cards/>
  <router-view></router-view>
</template>

<script>
import HomeSlider from '@/components/Home/HomeSlider.vue';
import Services from '@/components/Home/Services.vue';
import News from '@/components/Home/News.vue';
import About from '@/components/Home/About.vue';
import App from '@/components/Home/App.vue';
import Cards from '@/components/Home/Cards.vue';

export default {
  name: 'DashBoardView',
  components:{
    HomeSlider,
    Services,
    News,
    About,
    App,
    Cards
  },
  created(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
}
</script>
